export function isStandalone() {
  return window.matchMedia("(display-mode: standalone)").matches || navigator.standalone === true;
}

export function installationSteps(userAgent, platform, maxTouchPoints) {
  const ios = /iPad|iPhone|iPod/.test(userAgent) || (platform === "MacIntel" && maxTouchPoints > 1);
  if (ios) return [
    "Откройте сайт MetaCard в Safari.",
    "Нажмите «Поделиться» и выберите «На экран Домой».",
    "Если есть переключатель «Открывать как веб-приложение», включите его и нажмите «Добавить».",
  ];
  if (/Android/i.test(userAgent)) return [
    "Откройте сайт MetaCard в Chrome или другом браузере с поддержкой установки.",
    "В меню браузера выберите «Установить приложение» или «Добавить на главный экран».",
    "Подтвердите установку — иконка MetaCard появится на устройстве.",
  ];
  return [
    "Откройте сайт MetaCard в Chrome или Edge.",
    "Нажмите значок установки в адресной строке или выберите установку приложения в меню браузера.",
    "В Safari на Mac используйте меню «Файл → Добавить в Dock».",
  ];
}
